<template>
  <component :is="componentName" v-bind="$props" :placeholder="defaultPlaceholder" v-on="$listeners">
    <template v-slot:prefix>
      <slot name="prefix" />
    </template>
    <template v-slot:select-info>
      <slot name="select-info" />
    </template>
  </component>
</template>

<script>
import SelectDesktop from './Desktop'
import SelectDesktopColumns from './DesktopColumns'
import SelectMobile from './Mobile'
import SelectMobileColumns from './MobileColumns'
import { select, selectColumns } from './mixins'
export default {
  name: 'SelectResponse',
  components: {
    SelectDesktop,
    SelectDesktopColumns,
    SelectMobile,
    SelectMobileColumns
  },
  props: Object.assign({}, select.props, selectColumns.props),
  computed: {
    defaultPlaceholder () {
      return this.placeholder || this.L10n('select')
    },
    componentName () {
      let name = 'Select'
      // Mobile <-> Desktop
      name += this.$root.isMobile ? 'Mobile' : 'Desktop'
      // Columns <-> Default
      name += this.columns.length ? 'Columns' : ''
      return name
    }
  },
  methods: {
    // TODO INTERFACE
    focus () {
      this.$refs.select.focus()
    }
  }
}
</script>
